import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { User, ArrowRight, LogOut, ShoppingBag } from 'lucide-react';

const Header = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');
  const user = userStr ? JSON.parse(userStr) : null;

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/');
  };

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-[#e5e5e5]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" data-testid="logo-link">
            <span className="font-playfair text-lg md:text-2xl font-bold text-[#0d0d0d]">
              BusinessMint <span className="text-[#D4AF37]">PR</span>
            </span>
          </Link>
        
        <nav className="hidden md:flex items-center gap-8">
          <Link 
            to="/" 
            data-testid="nav-home-link"
            className="link-underline font-manrope text-sm text-[#737373] hover:text-[#1a1a1a] transition-colors duration-300"
          >
            Home
          </Link>
          <Link 
            to="/marketplace" 
            data-testid="nav-marketplace-link"
            className="link-underline font-manrope text-sm text-[#737373] hover:text-[#1a1a1a] transition-colors duration-300"
          >
            Marketplace
          </Link>
          <Link 
            to="/insights" 
            data-testid="nav-insights-link"
            className="link-underline font-manrope text-sm text-[#737373] hover:text-[#1a1a1a] transition-colors duration-300"
          >
            Insights
          </Link>
          <Link 
            to="/about" 
            data-testid="nav-about-link"
            className="link-underline font-manrope text-sm text-[#737373] hover:text-[#1a1a1a] transition-colors duration-300"
          >
            About
          </Link>
          <Link 
            to="/contact" 
            data-testid="nav-contact-link"
            className="link-underline font-manrope text-sm text-[#737373] hover:text-[#1a1a1a] transition-colors duration-300"
          >
            Contact
          </Link>
        </nav>
        
        <div className="flex items-center gap-3 md:gap-4">
          {token && user ? (
            <>
              <Link 
                to="/my-orders" 
                data-testid="nav-orders-link"
                className="hidden sm:flex items-center gap-2 font-manrope text-sm text-[#737373] hover:text-[#1a1a1a] transition-colors duration-300"
              >
                <ShoppingBag className="w-4 h-4" />
                <span className="hidden md:inline">My Orders</span>
              </Link>
              {user.role === 'partner' && (
                <Link 
                  to="/partner/dashboard" 
                  data-testid="nav-partner-link"
                  className="font-manrope text-sm text-[#D4AF37] hover:text-[#B8960F] transition-colors duration-300 font-semibold"
                >
                  Partner
                </Link>
              )}
              {user.role === 'admin' && (
                <Link 
                  to="/admin" 
                  data-testid="nav-admin-link"
                  className="font-manrope text-sm text-[#737373] hover:text-[#1a1a1a] transition-colors duration-300"
                >
                  Admin
                </Link>
              )}
              <div className="flex items-center gap-2 px-3 py-2 bg-[#f5f5f5] border border-[#e5e5e5]">
                <User className="w-4 h-4 text-[#737373]" />
                <span className="font-manrope text-sm text-[#1a1a1a] hidden sm:inline">{user.name?.split(' ')[0]}</span>
              </div>
              <button
                onClick={handleLogout}
                data-testid="nav-logout-button"
                className="p-2 text-[#737373] hover:text-[#1a1a1a] hover:bg-[#f5f5f5] transition-colors"
                title="Logout"
              >
                <LogOut className="w-4 h-4" />
              </button>
            </>
          ) : (
            <Link 
              to="/login" 
              data-testid="nav-login-link"
              className="font-manrope text-sm text-[#737373] hover:text-[#1a1a1a] transition-colors duration-300"
            >
              Login
            </Link>
          )}
          <Link
            to="/marketplace"
            data-testid="nav-browse-cta"
            className="btn-hover flex items-center gap-2 px-4 py-2 md:px-6 md:py-3 bg-[#D4AF37] text-[#0d0d0d] font-manrope text-xs uppercase tracking-wider font-semibold hover:bg-[#B8960F]"
          >
            <span className="hidden sm:inline">Explore</span> Services
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
